import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import {
  isValidPangkat,
  checkPangkatAndJenjang,
  getPangkatGolongan,
} from 'app/KinerjaShared/utils/pangkat'
import { isValidJenjang, mapJenjangName } from 'app/KinerjaShared/utils/jenjang'
import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'
import { PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { DescriptionListItem } from 'app/KinerjaShared/components/DescriptionList'

import type { Jenjang, KinerjaProfil } from 'types/kinerja'

interface PanelProfilProps {
  profile: KinerjaProfil
}

export default function PanelProfil({
  profile: currentProfile,
}: PanelProfilProps) {
  const schoolCtx = useSchoolContext()

  const router = useRouter()

  const pangkatGolongan = isValidPangkat(currentProfile.pangkatGolongan)
    ? currentProfile.pangkatGolongan
    : '-'

  let jenjang = '-'

  if (currentProfile.kategoriPegawai === 'PNS') {
    jenjang = checkPangkatAndJenjang(
      currentProfile.pangkatGolongan,
      currentProfile.jenjang.toLowerCase() as Jenjang
    )
      ? currentProfile.jenjang
      : '-'
  } else if (currentProfile.kategoriPegawai === 'PPPK') {
    jenjang = isValidJenjang(currentProfile.jenjang)
      ? currentProfile.jenjang
      : '-'
  }

  const handleConfirm = async () => {
    router.push(
      `${PENGELOLAAN_KINERJA_KSPNF_PENILAI_PATH}/periksa/${schoolCtx.currentNpsn}`
    )
  }

  return (
    <div className="p-9" data-testid="panel-profil">
      <div className="rounded-lg bg-white mt-9 max-w-7xl m-auto">
        <div className="p-9 border-b">
          <Text variant="display-sm" className="mb-6">
            Cek data diri Anda
          </Text>
          <div className="flex flex-col gap-3">
            <DescriptionListItem label="Nama" value={currentProfile.nama} />
            {currentProfile.kategoriPegawai !== 'UNDEFINED' && (
              <DescriptionListItem
                label="NIP"
                value={currentProfile.nip || '-'}
              />
            )}

            <DescriptionListItem
              label="Status Kepegawaian"
              value={currentProfile.statusPegawai || '-'}
            />

            {currentProfile.kategoriPegawai === 'PNS' && (
              <DescriptionListItem
                label="Pangkat, Golongan Ruang"
                value={getPangkatGolongan(pangkatGolongan)}
              />
            )}

            {currentProfile.kategoriPegawai !== 'UNDEFINED' && (
              <DescriptionListItem
                label="Jenjang Jabatan"
                value={mapJenjangName(jenjang)}
              />
            )}

            <DescriptionListItem
              label="Satuan Pendidikan Induk"
              value={
                schoolCtx.selectedSchoolName ?? currentProfile.satuanPendidikan
              }
            />
          </div>
        </div>
        <div className="flex py-4 px-7">
          <div className="ml-auto flex gap-5">
            <Button size="lg" onClick={handleConfirm}>
              Data sudah sesuai
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
